import { camelizeKeys } from 'humps';
import { get } from '@namespace/helpers';

export const getSignature = async () => {
  return get('/service/cs/v1/web-chat/user-data')
    .then(camelizeKeys)
    .then(({ data }) => data);
};
